export enum EUserStatus {
  Unconfirmed,
  Inactive,
  Active,
  Banned,
}

export enum EUserRole {
  SuperAdmin             = 'superadmin',
  IntranetUser           = 'intranetuser',
  Admin                  = 'admin',
  Photographer           = 'photographer',
  AuctionManager         = 'auctionmanager',
  PurchaseProcessor      = 'purchaseprocessor',
  RecoveryManager        = 'recoverymanager',
  CancellationSpecialist = 'cancellationspecialist',
}

export enum EAppPage {
  Dashboard           = '/dashboard',
  AccountManagement   = '/account-management',
  Auctions            = '/auctions',
  InvoiceManagement   = '/invoice-management',
  RegisteredBidders   = '/registered-bidders',
  ManageIntranetUsers = '/manage-intranet-users',
  NationalAdManager   = '/national-ad-manager',
}

export enum EMonthNumber {
  Jan = 1,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec,
}

export enum ECommentType {
  Bidder  = 'user',
  Account = 'credit-union',
}

export enum EUploadTypes {
  Image,
  All
}
